import React from "react";
import dayjs from 'dayjs';
import Calendar from "Components/Calendar";
import api from "../../utils/api";
import utils from "../../utils";
import { Button, Col, Row } from "antd";
import "./Appointment.scss";
import icons from "Common/Icons";
import { connect } from "react-redux";
import { historyState } from "../../store/slice/history-slice";
import Loader from "Components/Loader";
import { CONSTANTS } from "utils/constant";
import BackButton from "Components/BackButton";
import CommonButton from "Components/CommonButton";
class ScheduleAppointment extends React.Component {
  _baseClassName = "schedule-appointment-container";
  constructor(props) {
    super(props);
    this.state = {
      user_details: this.props.user_details,
      slotData: [],
      slot_details: [],
      flag: false,
    };
  }
  handleSlotSelection(value) {
    this.setState({
      selectedSlot: value,
      showTimeSlotWarning: false,
    });
  }
  handleBookAppointment() {
    let subscription = localStorage.getItem("subscription") === null ? {} : JSON.parse(localStorage.getItem("subscription"));
    let datetime = {
      appointment_date_time: this.state.selectedSlot,
      speciality_id:this.props.filters.sortBy.includes('all')?[]:this.props.filters.sortBy,
    };
    this.setState({ isLoading: true })
    if(this.state.selectedSlot){
      api
      .schedule_appointment_available_doctors(datetime)
      .then((response) => {
        if (response.data?.status == 200) {
          this.setState({ slot_details: response.data?.data });
          if (response.data?.data.is_first_appointment) {
            return api.schedule_book_appointment({ ...datetime, membership_type: subscription?.membership_type });
          } else {
            this.props.historyState(response.data?.data);
            this.setState({ isLoading: false })
            this.props.history.push({
              pathname: `/logged-in-user/select-doctor`,
              selected_date: "09/07/2022",
              slot_details: this.state.slot_details,
            });
          }
        }else{
          this.setState({ isLoading: false })
        }
      })
      .then((res) => {
        if (res.data?.status == 200) {
          this.setState({ isLoading: false })
          let subscription = localStorage.getItem("subscription") === null ? {} : JSON.parse(localStorage.getItem("subscription"));
          let output = { ...subscription, ...res.data?.data }
          localStorage.setItem("subscription", JSON.stringify(output));
          this.props.history.push({
            pathname: `/logged-in-user/consultation-history`,
            selected_date: "09/07/2022",
          })
        } else if (res.data?.status == 400) {
          this.setState({ isLoading: false })
          utils.Toast({ type: "warning", message: res.data?.message });
          this.setState({ selectedSlot: null });
        }
      })
      .catch((err) => { });
    }else{
      utils.Toast({ type:"warning", message: "Please select your time slot."});
      this.setState({isLoading: false});
    }
  }
  componentDidMount() {
    this.setState({
      selectedDate: utils.FormatDate(this.props.currentOffsetDateTime), isLoading:true   // get patient status date & time 
    });
    this.getAppointmentSlots(this.props.currentOffsetDateTime);
  }
  getAppointmentSlots(formatedDate) {
    if(!(dayjs(this.props.currentOffsetDateTime).format('DD/MM/YYYY') == dayjs(formatedDate).format('DD/MM/YYYY'))){
      formatedDate = dayjs(formatedDate).format('YYYY-MM-DD 00:00:00')
    }
    api
      .schedule_appointment_available_slots({
        appointment_date_time: formatedDate,
      })
      .then((res) => {
        let response = res.data?.data;
        let newdata = Object.keys(response || {}).map((m) => {
          return {
            label: utils.Capitalize(m),
            slots: response[m],
          };
        });
        let flag = newdata.some((item) => item.slots?.length > 0);
        this.setState({
          slotData: newdata,
          isSlotsAvailable: flag,
          isLoading:false
        });
        if (res.data?.status == 400) {
          // utils.Toast({ type: "error", message: res.data?.message });
          this.setState({ selectedSlot: null });
        }
      });
  }
  handleDateSelection(value) {
    if(value < dayjs(this.props.currentOffsetDateTime).startOf("day") ||
    dayjs(this.props.currentOffsetDateTime).add(7, "days") <= value
    || value > dayjs(JSON.parse(localStorage.getItem("subscription"))?.membership_expiry_date)){
      return;
    }  
    let formatedDate = utils.FormatDate(value, "UTC", "days");
    if(this.state.selectedDate == formatedDate)
      return;
    this.setState({
      selectedDate: formatedDate,
      selectedSlot: undefined,
    });
    this.getAppointmentSlots(formatedDate); 
  }
  navigateBackPage(){
     this.props.history.goBack();
  }
  render() {

    return (
      <div>
        {this.state.isLoading ? <Loader /> :
          <div className={this._baseClassName}>
            <div className="schedule-appointment-top-content">
            <div>
              <BackButton navigateBackPage={this.navigateBackPage.bind(this)} />
            </div>
            <div className="schedule-appointment-title" style={{textAlign:"center"}}>
              <div>
              {CONSTANTS.NEW_APPOINTMENT}</div><div style={{fontSize:"medium"}}>Select your preferred time slot and doctor to book appointment</div>
              
            </div>
            <div>
            </div>
            </div>
            {/* <div style={{marginBottom:"10px"}} onClick={() =>{this.navigateBackPage(this)}} className="previous-page-button">{CONSTANTS.BACK_TO_PREVIOUS_PAGE}</div> */}
            <Row className="main-content">
              <Col xs={24} className="main-content-wrapper">
                <Row className={`main-content-body`}>
                  <Col xs={24} md={11}
                    className="left-content"
                  >
                    <div className="wrapper-header">
                      {/* <div className="round-circle"></div> */}
                      <div className="title-content">{`${CONSTANTS.SELECT_YOUR_DATE}`}</div>
                    </div>
                    <div className="content-body">
                      <Calendar
                        onSelect={this.handleDateSelection.bind(this)}
                        defaultValue={dayjs(this.props.currentOffsetDateTime)}    // get patient status date & time 
                        iconHide={true}
                        showToday={false}
                        disabledDate={(current) =>
                          current < dayjs(this.props.currentOffsetDateTime).startOf("day") ||
                          dayjs(this.props.currentOffsetDateTime).add(7, "days") <= current
                          || current > dayjs(JSON.parse(localStorage.getItem("subscription"))?.membership_expiry_date)
                        }
                      />
                      <div className="slected-date">{CONSTANTS.SELECTED_DATE}: <span className="selected-date-content">{utils.FormatDate(this.state.selectedDate, "DATE_9")}</span></div>
                    </div>
                  </Col>
                  <Col xs={24} md={11} className="right-content">
                    <div className="wrapper-header">
                      {/* <div className="round-circle"></div> */}
                      <div className="title-content">{`${CONSTANTS.SELECT_YOUR_TIME_SLOT}`}</div>
                    </div>
                    <div className="content-body">
                      {!this.state.isSlotsAvailable ? <div className="no-slots-text"> {CONSTANTS.NO_SLOTS_AVAILABLE} </div> :
                        <>
                          {(this.state.slotData || []).map((obj, i) => {
                            return (
                              <div className="slots-group" key={i}>
                                {obj["slots"].length > 0 ? <div className="slots-header">
                                  <div className="slots-label">
                                    {/* <img src={icons.star} /> &nbsp;  */}
                                    {obj["label"]}:
                                  </div>
                                </div> : ''}
                                <div className="slots-container">
                                  {(obj["slots"] || []).map((slot, index) => {
                                    return (
                                      <div
                                        className={`slot${this.state.selectedSlot == slot
                                          ? " selected"
                                          : ""
                                          } ${dayjs(this.props.currentOffsetDateTime) > dayjs(slot) ? "disabled" : ""}
                                        ${dayjs(JSON.parse(localStorage.getItem("subscription"))?.membership_expiry_date) < dayjs(slot) ? "disabled" : ""}`}
                                        onClick={(e) => dayjs(this.props.currentOffsetDateTime) > dayjs(slot) ? "disabled" : "" || dayjs(JSON.parse(localStorage.getItem("subscription"))?.membership_expiry_date) < dayjs(slot) ? undefined : this.handleSlotSelection(slot)}
                                        key={index}
                                      >
                                        {utils.FormatDate(slot, "TIME_5")}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            );
                          })}
                        </>
                      }
                    </div>
                  </Col>
                  {/* )} */}
                </Row>
                <Row className="bottom-content">
                  <Col>
                    {/* <Button
                      // className={option.disabled ? addClass : removeClass}
                      // disabled={
                      //   this.state.selectedSlot == undefined ? "disabled" : ""
                      // }
                      onClick={this.handleBookAppointment.bind(this)}
                      style={this.state.selectedSlot ? { cursor: "pointer" } : { cursor: "default" }}
                    >
                      {CONSTANTS.PROCEED}
                    </Button> */}
                    <CommonButton className="common-button-green" label={CONSTANTS.PROCEED} onClick={this.handleBookAppointment.bind(this)} style={this.state.selectedSlot ? { cursor: "pointer" } : { cursor: "default" }}/>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user_details: state.loginReducer.user_details,
    filters: state.doctorfilterReducer.filters,
  }
}
const mapDispatchToProps = {
  historyState,
}
export default connect(mapStateToProps, mapDispatchToProps)(ScheduleAppointment)